/** Home quick-link grid is always 4 columns on mobile. */
export const HOME_TILE_GRID_COLUMNS = 4;

const COL_SPAN_CLASS: Record<number, string> = {
  1: 'col-span-1',
  2: 'col-span-2',
  3: 'col-span-3',
  4: 'col-span-4',
};

export function clampTileColumnSpan(value?: number | null): number {
  const n = Number(value);
  if (!Number.isFinite(n)) return 1;
  return Math.min(HOME_TILE_GRID_COLUMNS, Math.max(1, Math.round(n)));
}

export function homeTileGridClass(): string {
  return 'grid grid-cols-4 gap-3';
}

export function tileColSpanClass(span?: number | null): string {
  return COL_SPAN_CLASS[clampTileColumnSpan(span)] ?? 'col-span-1';
}
